// src/constants/gameConstants.js

// Oyun sabitleri
export const GRID_W = 12;
export const GRID_H = 9;
export const INITIAL_CELLS = 5;
export const MAX_ATTACKS_PER_TURN = 4;
export const WINNING_PERCENTAGE = 0.6;
export const MAX_TURNS = 25;
export const MAX_PLAYERS = 5;

// Ülke verileri - PNG bayraklarla (Yüksek Kontrastlı Renk Paleti Kullanılmıştır)
export const COUNTRY_DATA = {
  // Kırmızı & Kırmızıya Yakın
  CN: {
    code: 'CN',
    name: 'Çin',
    flag: 'https://flagcdn.com/w80/cn.png',
    color: '#DC143C', // Crimson (Koyu Kırmızı)
    displayName: 'ÇİN'
  },
  TR: {
    code: 'TR',
    name: 'Türkiye',
    flag: 'https://flagcdn.com/w80/tr.png',
    color: '#800000', // Maroon (Bordo/Kızıl)
    displayName: 'TÜR'
  },
  FR: {
    code: 'FR',
    name: 'Fransa',
    flag: 'https://flagcdn.com/w80/fr.png',
    color: '#FF4500', // Orange Red (Turuncu Kırmızı)
    displayName: 'FRA'
  },
  JP: {
    code: 'JP',
    name: 'Japonya',
    flag: 'https://flagcdn.com/w80/jp.png',
    color: '#B22222', // Firebrick (Tuğla Kırmızısı)
    displayName: 'JAP'
  },
  ES: {
    code: 'ES',
    name: 'İspanya',
    flag: 'https://flagcdn.com/w80/es.png',
    color: '#FF7F50', // Coral (Mercan)
    displayName: 'İSP'
  },
  KP: {
    code: 'KP',
    name: 'Kuzey Kore',
    flag: 'https://flagcdn.com/w80/kp.png',
    color: '#A52A2A', // Brown (Kahverengi)
    displayName: 'KUZKOR'
  },

  // Mavi & Maviye Yakın
  US: {
    code: 'US',
    name: 'Amerika',
    flag: 'https://flagcdn.com/w80/us.png',
    color: '#1E90FF', // Dodger Blue (Canlı Mavi)
    displayName: 'USA'
  },
  RU: {
    code: 'RU',
    name: 'Rusya',
    flag: 'https://flagcdn.com/w80/ru.png',
    color: '#000080', // Navy Blue (Lacivert)
    displayName: 'RUS'
  },
  KR: { // Güney Kore
    code: 'KR',
    name: 'Güney Kore',
    flag: 'https://flagcdn.com/w80/kr.png',
    color: '#4169E1', // Royal Blue (Kraliyet Mavisi)
    displayName: 'KOR'
  },
  GB: {
    code: 'GB',
    name: 'Birleşik Krallık',
    flag: 'https://flagcdn.com/w80/gb.png',
    color: '#00BFFF', // Deep Sky Blue (Açık Mavi)
    displayName: 'GB'
  },
  AU: {
    code: 'AU',
    name: 'Avustralya',
    flag: 'https://flagcdn.com/w80/au.png',
    color: '#6A5ACD', // Slate Blue (Eflatun Mavi)
    displayName: 'AVS'
  },
  IL: {
    code: 'IL',
    name: 'İsrail',
    flag: 'https://flagcdn.com/w80/il.png',
    color: '#ADD8E6', // Light Blue (Çok Açık Mavi)
    displayName: 'İSR'
  },
  GR: {
    code: 'GR',
    name: 'Yunanistan',
    flag: 'https://flagcdn.com/w80/gr.png',
    color: '#ADD8E6', // Light Blue (Çok Açık Mavi)
    displayName: 'YUN'
  },

  // Yeşil & Yeşile Yakın
  AZ: { // Pakistan
    code: 'AZ',
    name: 'Azerbaycanstan',
    flag: 'https://flagcdn.com/w80/az.png',
    color: '#228B22', // Forest Green (Koyu Yeşil)
    displayName: 'AZR'
  },
  PK: { // Pakistan
    code: 'PK',
    name: 'Pakistan',
    flag: 'https://flagcdn.com/w80/pk.png',
    color: '#228B22', // Forest Green (Koyu Yeşil)
    displayName: 'PAK'
  },
  IT: {
    code: 'IT',
    name: 'İtalya',
    flag: 'https://flagcdn.com/w80/it.png',
    color: '#00FF7F', // Spring Green (Canlı Yeşil)
    displayName: 'İTA'
  },
  BR: {
    code: 'BR',
    name: 'Brezilya',
    flag: 'https://flagcdn.com/w80/br.png',
    color: '#7CFC00', // Lawn Green (Çim Yeşili)
    displayName: 'BRE'
  },
  IR: { // İran
    code: 'IR',
    name: 'İran',
    flag: 'https://flagcdn.com/w80/ir.png',
    color: '#3CB371', // Medium Sea Green (Deniz Yeşili)
    displayName: 'İRAN'
  },

  // Sarı, Turuncu ve Mor Tonları (Yüksek Kontrast)
  IN: {
    code: 'IN',
    name: 'Hindistan',
    flag: 'https://flagcdn.com/w80/in.png',
    color: '#FFA500', // Orange (Canlı Turuncu)
    displayName: 'HIN'
  },
  DE: {
    code: 'DE',
    name: 'Almanya',
    flag: 'https://flagcdn.com/w80/de.png',
    color: '#FFD700', // Gold (Altın Sarısı)
    displayName: 'ALM'
  },
  UA: {
    code: 'UA',
    name: 'Ukrayna',
    flag: 'https://flagcdn.com/w80/ua.png',
    color: '#DAA520', // Goldenrod (Soluk Altın)
    displayName: 'UKR'
  },
  AM: { // Ermenistan
    code: 'AM',
    name: 'Ermenistan',
    flag: 'https://flagcdn.com/w80/am.png',
    color: '#ce6300ff', // Dark Orchid (Koyu Orkide/Mor)
    displayName: 'ERM'
  }
};

export const COUNTRY_DEFAULTS = Object.values(COUNTRY_DATA);

export const getFlagUrls = (countryCode) => {
  if (!countryCode) return null;
  
  const code = countryCode === 'UK' ? 'gb' : countryCode.toLowerCase();
  return {
    small: `https://flagcdn.com/w40/${code}.png`,
    large: `https://flagcdn.com/w80/${code}.png`,
    alt: COUNTRY_DATA[countryCode]?.name || countryCode
  };
};

const NAME_TO_COUNTRY_MAP = {
  'türk': 'TR', 'turk': 'TR', 'türkiye': 'TR', 'turkey': 'TR',
  'amerika': 'US', 'usa': 'US', 'united states': 'US', 'america': 'US',
  'çin': 'CN', 'cin': 'CN', 'china': 'CN',
  'rusya': 'RU', 'russia': 'RU', 'rus': 'RU',
  'almanya': 'DE', 'germany': 'DE', 'alm': 'DE', 'deutschland': 'DE',
  'japonya': 'JP', 'japan': 'JP', 'jap': 'JP',
  'fransa': 'FR', 'france': 'FR', 'fra': 'FR',
  'ingiltere': 'GB', 'britain': 'GB', 'uk': 'GB', 'united kingdom': 'GB', 'great britain': 'GB'
};

export const getCountryCodeFromName = (name) => {
  if (!name) return null;
  const nameLower = name.toLowerCase();
  for (const [key, value] of Object.entries(NAME_TO_COUNTRY_MAP)) {
    if (nameLower.includes(key)) return value;
  }
  return null;
};

export const getFallbackFlag = (countryCode) => {
  return COUNTRY_DATA[countryCode]?.flag || 'https://flagcdn.com/w80/xx.png';
};

export const POWER_CONSTANTS = {
  MAX_ATTACK_POWER: 6,
  MAX_DEFENSE_POWER: 5,
  ATTACK_BONUS_MULTIPLIER: 0.08,
  DEFENSE_BONUS_MULTIPLIER: 0.06,
  ATTACK_POWER_DIVIDER: 1.5,
  DEFENSE_POWER_DIVIDER: 1.8
};

export const BATTLE_CONSTANTS = {
  BASE_ATTACKER_BONUS: 0.3,
  CRITICAL_HIT_CHANCE: 0.15,
  CRITICAL_HIT_BONUS: 2.5,
  BASE_ATTACK_SUCCESS_CHANCE: 0.6,
};